module.exports = __webpack_public_path__ + "static/media/back.322bfb07.svg";